import React from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';

// TODO: update hints for future russian translation
export default class DateHint extends React.PureComponent {
  static getDateHint = date => {
    const now = dayjs();
    const hinted = dayjs(date);

    if (now.isSame(hinted, 'day')) {
      return 'Today';
    }

    if (now.add(1, 'day').isSame(hinted, 'day')) {
      return 'Tomorrow';
    }

    if (now.add(1, 'week').isSame(hinted, 'week')) {
      return 'Next week';
    }

    return false;
  };

  constructor(props) {
    super(props);

    this.state = {hint: DateHint.getDateHint(props.date)};
  }

  componentWillReceiveProps(nextProps) {
    const {date} = nextProps;

    if (date !== this.props.date) {
      this.setState({hint: DateHint.getDateHint(date)})
    }
  }

  render() {
    const {hint} = this.state;

    return hint;
  }
}



// WEBPACK FOOTER //
// ./components/dates/DateHint.js